import { CHANGE_BANK_ACCOUNT_PARAM } from '../constants';
/** True when the customer reached the connect screens from the account they already have on file. */
function isChangingBankAccount(search) {
    return new URLSearchParams(search).get(CHANGE_BANK_ACCOUNT_PARAM) === '1';
}
export default isChangingBankAccount;
